import { apiSlice } from "../../app/api/apiSlice";

const URL = "/support";

export const supportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyTickets: builder.query({
      query: () => `${URL}/tickets`,
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map((ticket) => ({
                type: "Ticket",
                id: ticket._id || ticket.id,
              })),
              { type: "Ticket", id: "MY_LIST" },
            ]
          : [{ type: "Ticket", id: "MY_LIST" }],
    }),
    createTicket: builder.mutation({
      query: (ticket) => ({
        url: `${URL}/tickets`,
        method: "POST",
        body: ticket,
      }),
      invalidatesTags: [{ type: "Ticket", id: "MY_LIST" }],
    }),
    getTicketById: builder.query({
      query: ({ id, superView = false }) =>
        superView ? `${URL}/super/tickets/${id}` : `${URL}/tickets/${id}`,
      providesTags: (_res, _err, { id }) => [{ type: "Ticket", id }],
    }),
    addTicketComment: builder.mutation({
      query: ({ id, message, superView = false }) => ({
        url: superView
          ? `${URL}/super/tickets/${id}/comments`
          : `${URL}/tickets/${id}/comments`,
        method: "POST",
        body: { message },
      }),
      invalidatesTags: (_res, _err, { id }) => [
        { type: "Ticket", id },
        { type: "Ticket", id: "MY_LIST" },
        { type: "Ticket", id: "SUPER_LIST" },
      ],
    }),
    getSuperTickets: builder.query({
      query: () => `${URL}/super/tickets`,
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map((ticket) => ({
                type: "Ticket",
                id: ticket._id || ticket.id,
              })),
              { type: "Ticket", id: "SUPER_LIST" },
            ]
          : [{ type: "Ticket", id: "SUPER_LIST" }],
    }),
    updateSuperTicket: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `${URL}/super/tickets/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (_res, _err, { id }) => [
        { type: "Ticket", id },
        { type: "Ticket", id: "MY_LIST" },
        { type: "Ticket", id: "SUPER_LIST" },
      ],
    }),
    getSuperAssignableUsers: builder.query({
      query: ({ tenantId }) => `${URL}/super/users?tenantId=${tenantId}`,
      providesTags: [{ type: "Ticket", id: "ASSIGNABLE_USERS" }],
    }),
  }),
});

export const {
  useGetMyTicketsQuery,
  useCreateTicketMutation,
  useGetTicketByIdQuery,
  useAddTicketCommentMutation,
  useGetSuperTicketsQuery,
  useUpdateSuperTicketMutation,
  useGetSuperAssignableUsersQuery,
} = supportApiSlice;
